import {
  PriceIndexData,
  FilterParams,
  PriceIndexResponse,
  MarketAnalysisMetrics,
} from "@/types/price-index";
import { axiosWithToken, axiosWithoutToken } from "@/utils/axios";

class PriceIndexServiceClass {
  /**
   * Fetch price index data with optional filtering
   */
  GetPriceIndexData(filters?: FilterParams) {
    return axiosWithoutToken.get<PriceIndexResponse>("/price-index", {
      params: filters,
    });
  }

  /**
   * Fetch price index data for authenticated users
   */
  GetPriceIndexDataAuth(filters?: FilterParams) {
    return axiosWithToken().get<PriceIndexResponse>("/price-index", {
      params: filters,
    });
  }

  /**
   * Fetch price index data by location
   */
  GetPriceIndexByLocation(
    location: string,
    filters?: Omit<FilterParams, "location">,
  ) {
    return axiosWithoutToken.get<PriceIndexResponse>(
      `/price-index/location/${location}`,
      {
        params: filters,
      },
    );
  }

  /**
   * Fetch price index data by property type
   */
  GetPriceIndexByPropertyType(
    propertyType: string,
    filters?: Omit<FilterParams, "propertyType">,
  ) {
    return axiosWithoutToken.get<PriceIndexResponse>(
      `/price-index/property-type/${propertyType}`,
      {
        params: filters,
      },
    );
  }

  /**
   * Fetch market analysis metrics
   */
  GetMarketAnalysis(filters?: FilterParams) {
    return axiosWithoutToken.get<MarketAnalysisMetrics>(
      "/price-index/market-analysis",
      {
        params: filters,
      },
    );
  }

  /**
   * Fetch available locations for filtering
   */
  GetAvailableLocations() {
    return axiosWithoutToken.get<string[]>("/price-index/locations");
  }

  /**
   * Fetch available property types for filtering
   */
  GetAvailablePropertyTypes() {
    return axiosWithoutToken.get<string[]>("/price-index/property-types");
  }

  /**
   * Fetch historical trend data
   */
  GetHistoricalTrends(filters?: FilterParams) {
    return axiosWithoutToken.get<PriceIndexData[]>("/price-index/trends", {
      params: filters,
    });
  }

  /**
   * Export price index data (authenticated)
   */
  ExportPriceIndexData(filters?: FilterParams, format: "csv" | "json" = "csv") {
    return axiosWithToken().get(`/price-index/export`, {
      params: { ...filters, format },
      responseType: "blob",
    });
  }
}

const PriceIndexService = new PriceIndexServiceClass();
export default PriceIndexService;
